export default [
    // {
    //     path: '/dmhc',
    //     name: 'workshop.dmhc',
    //     components: {
    //         default: () => import('@/modules/events/workshops/dmhc/views/Index.vue'),
    //         footer: () => import('../views/public/footer/index.vue')
    //     },
    //     meta: {
    //         registrationSource: 'DMHC Free Registration'
    //     }
    // },
    {
        path: '/masterclass/:eventCode',
        name: 'event.masterclass.index',
        props: {
            default: true
        },
        components: {
            default: () => import(/* webpackChunkName: "masterclass" */ '@/modules/events/masterclass/views/index.vue'),
            header: () => import(/* webpackChunkName: "masterclass" */ '@/modules/events/masterclass/components/TheHeader.vue'),
            footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
        }
    },
    {
        path: '/masterclass/:eventCode/subscribers',
        name: 'event.masterclass.index.subscribers',
        props: {
            default: true
        },
        components: {
            default: () => import(/* webpackChunkName: "masterclass" */ '@/modules/events/masterclass/views/index.vue'),
            header: () => import(/* webpackChunkName: "masterclass" */ '@/modules/events/masterclass/components/TheHeader.vue'),
            footer: () => import(/* webpackChunkName: "masterclass" */  '@/modules/events/masterclass/components/TheFooter.vue')
        }
    },
    {
        path: '/masterclass/:eventCode/confirmation',
        name: 'event.masterclass.confirmation',
        props: {
            default: true
        },
        components: {
            default: () => import(/* webpackChunkName: "masterclass" */ '@/modules/events/masterclass/views/confirmation.vue'),
            header: () => import(/* webpackChunkName: "masterclass" */ '@/modules/events/masterclass/components/TheHeader.vue'),
            footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
        }
    },
    {
        path: '/summit',
        name: 'mhbtg.index',
        components: {
            default: () => import('@/modules/events/summit/views/Index.vue'),
            footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
        },
        meta: {
            eventId: 44
        }
    },
    // {
    //     path: '/childsummit',
    //     name: 'childsummit.index',
    //     components: {
    //         default: () => import('@/modules/events/childSummit/views/Index.vue'),
    //         footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
    //     },
    //     meta: {
    //         eventId: '31'
    //     }
    // },

    // {
    //     path: '/childsummit/ccpa',
    //     name: 'childsummit.ccpa.index',
    //     components: {
    //         default: () => import('@/modules/events/childSummit/views/Index.vue'),
    //         footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
    //     },
    //     meta: {
    //         eventId: '31'
    //     }
    // },

    // {
    //     path: '/childsummit/nbcc',
    //     name: 'childsummit.nbcc.index',
    //     components: {
    //         default: () => import('@/modules/events/childSummit/views/Index.vue'),
    //         footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
    //     },
    //     meta: {
    //         eventId: '31'
    //     }
    // },

    // {
    //     path: '/childsummit/aca',
    //     name: 'childsummit.aca.index',
    //     components: {
    //         default: () => import('@/modules/events/childSummit/views/Index.vue'),
    //         footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
    //     },
    //     meta: {
    //         eventId: '31'
    //     }
    // },

    {
        path: '/childsummit/upgrade',
        name: 'childsummit.upgrade',
        components: {
            default: () => import('@/modules/events/childSummit/views/Upgrade.vue'),
            footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
        },
        meta: {
            eventId: '31'
        }
    },

    {
        path: '/childsummit/upgrade/confirmation',
        name: 'childsummit.upgrade.confirmation',
        components: {
            default: () => import('@/modules/events/childSummit/components/Confirmation.vue'),
            footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
        },
        meta: {
            registrationSource: 'upgrade'
        }
    },

    // {
    //     path: '/childsummit/confirmation',
    //     name: 'childsummit.confirmation',
    //     components: {
    //         default: () => import('@/modules/events/childSummit/components/Confirmation.vue'),
    //         footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
    //     }
    // },
    // {
    //     path: '/childsummit/ccpa/confirmation',
    //     name: 'childsummit.ccpa.confirmation',
    //     components: {
    //         default: () => import('@/modules/events/childSummit/components/Confirmation.vue'),
    //         footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue')
    //     }
    // },

    // {
    //     path: '/childsummit/nbcc/confirmation',
    //     name: 'childsummit.nbcc.confirmation',
    //     components: {
    //         default: () => import('@/modules/events/childSummit/components/Confirmation.vue'),
    //         footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue')
    //     }
    // },

    // {
    //     path: '/childsummit/aca/confirmation',
    //     name: 'childsummit.aca.confirmation',
    //     components: {
    //         default: () => import('@/modules/events/childSummit/components/Confirmation.vue'),
    //         footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue')
    //     }
    // },

    // {
    //     path: '/summit/students',
    //     name: 'mhss.studnets.index',
    //     components: {
    //         default: () => import('@/modules/events/summit/views/Index.vue'),
    //         footer: () => import('@/modules/events/summit/components/TheFooter.vue')
    //     }
    // },
    {
        path: '/summit/confirmation',
        name: 'mhss.confirmation',
        components: {
            default: () => import('@/modules/events/summit/components/Confirmation.vue'),
            footer: () => import('@/modules/events/summit/components/TheFooter.vue')
        }
    },


    // ******************* Addictions Summit Routes ******************* //
    {
        path: '/addictions',
        name: 'mhss.index',
        components: {
            default: () => import('@/modules/events/mhss/views/Index.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            eventId: '41'
        }
    },
    {
        path: '/addictions/upgrade',
        name: 'mhss.upgrade',
        components: {
            default: () => import('@/modules/events/mhss/views/Upgrade.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            eventId: '41'
        }
    },
    {
        path: '/addictions/upgrade/confirmation',
        name: 'mhss.upgrade.confirmation',
        components: {
            default: () => import('@/modules/events/mhss/components/Confirmation.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            registrationSource: 'upgrade'
        }
    },
    {
        path: '/addictions/confirmation',
        name: 'mhss.confirmation',
        components: {
            default: () => import('@/modules/events/mhss/components/Confirmation.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        }
    },


    // ******************* Addictions ccpa Summit Routes ******************* //
    {
        path: '/addictions/ccpa',
        name: 'mhss.index',
        components: {
            default: () => import('@/modules/events/mhss/views/Index.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            eventId: '41'
        }
    },
    {
        path: '/addictions/ccpa/upgrade',
        name: 'mhss.upgrade',
        components: {
            default: () => import('@/modules/events/mhss/views/Upgrade.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            eventId: '41'
        }
    },
    {
        path: '/addictions/ccpa/upgrade/confirmation',
        name: 'mhss.upgrade.confirmation',
        components: {
            default: () => import('@/modules/events/mhss/components/Confirmation.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            registrationSource: 'upgrade'
        }
    },
    {
        path: '/addictions/ccpa/confirmation',
        name: 'mhss.confirmation',
        components: {
            default: () => import('@/modules/events/mhss/components/Confirmation.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        }
    },

    // ******************* Addictions ccpa Summit Routes ******************* //
    {
        path: '/addictions/ccpa',
        name: 'mhss.index',
        components: {
            default: () => import('@/modules/events/mhss/views/Index.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            eventId: '41'
        }
    },
    {
        path: '/addictions/ccpa/upgrade',
        name: 'mhss.upgrade',
        components: {
            default: () => import('@/modules/events/mhss/views/Upgrade.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            eventId: '41'
        }
    },
    {
        path: '/addictions/ccpa/upgrade/confirmation',
        name: 'mhss.upgrade.confirmation',
        components: {
            default: () => import('@/modules/events/mhss/components/Confirmation.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            registrationSource: 'upgrade'
        }
    },
    {
        path: '/addictions/ccpa/confirmation',
        name: 'mhss.confirmation',
        components: {
            default: () => import('@/modules/events/mhss/components/Confirmation.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        }
    },

    // ******************* Addictions aca Summit Routes ******************* //
    {
        path: '/addictions/aca',
        name: 'mhss.index',
        components: {
            default: () => import('@/modules/events/mhss/views/Index.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            eventId: '41'
        }
    },
    {
        path: '/addictions/aca/upgrade',
        name: 'mhss.upgrade',
        components: {
            default: () => import('@/modules/events/mhss/views/Upgrade.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            eventId: '41'
        }
    },
    {
        path: '/addictions/aca/upgrade/confirmation',
        name: 'mhss.upgrade.confirmation',
        components: {
            default: () => import('@/modules/events/mhss/components/Confirmation.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            registrationSource: 'upgrade'
        }
    },
    {
        path: '/addictions/aca/confirmation',
        name: 'mhss.confirmation',
        components: {
            default: () => import('@/modules/events/mhss/components/Confirmation.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        }
    },


    // ******************* Addictions naadac Summit Routes ******************* //
    {
        path: '/addictions/naadac',
        name: 'mhss.index',
        components: {
            default: () => import('@/modules/events/mhss/views/Index.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            eventId: '41'
        }
    },
    {
        path: '/addictions/naadac/upgrade',
        name: 'mhss.upgrade',
        components: {
            default: () => import('@/modules/events/mhss/views/Upgrade.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            eventId: '41'
        }
    },
    {
        path: '/addictions/naadac/upgrade/confirmation',
        name: 'mhss.upgrade.confirmation',
        components: {
            default: () => import('@/modules/events/mhss/components/Confirmation.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            registrationSource: 'upgrade'
        }
    },
    {
        path: '/addictions/naadac/confirmation',
        name: 'mhss.confirmation',
        components: {
            default: () => import('@/modules/events/mhss/components/Confirmation.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        }
    },

    // ******************* Addictions nbcc Summit Routes ******************* //
    {
        path: '/addictions/nbcc',
        name: 'mhss.index',
        components: {
            default: () => import('@/modules/events/mhss/views/Index.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            eventId: '41'
        }
    },
    {
        path: '/addictions/nbcc/upgrade',
        name: 'mhss.upgrade',
        components: {
            default: () => import('@/modules/events/mhss/views/Upgrade.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            eventId: '41'
        }
    },
    {
        path: '/addictions/nbcc/upgrade/confirmation',
        name: 'mhss.upgrade.confirmation',
        components: {
            default: () => import('@/modules/events/mhss/components/Confirmation.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        },
        meta: {
            registrationSource: 'upgrade'
        }
    },
    {
        path: '/addictions/nbcc/confirmation',
        name: 'mhss.confirmation',
        components: {
            default: () => import('@/modules/events/mhss/components/Confirmation.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
        }
    },
    
    {
        path: '/suicideprevention',
        name: 'summit.index',
        components: {
            default: () => import('@/modules/events/suicidePreventionSummit/views/Index.vue'),
            footer: () => import('@/modules/events/suicidePreventionSummit/components/TheFooter.vue'),
        },
        meta: {
            eventId: '46'
        }
    },
    {
        path: '/suicideprevention/confirmation',
        name: 'summit.confirmation',
        components: {
            default: () => import('@/modules/events/suicidePreventionSummit/views/Confirmation.vue'),
            footer: () => import('@/modules/events/suicidePreventionSummit/components/TheFooter.vue'),
        }
    },
    {
        path: '/suicideprevention/upgrade',
        name: 'summit.upgrade',
        components: {
            default: () => import('@/modules/events/suicidePreventionSummit/views/Upgrade.vue'),
            footer: () => import('@/modules/events/suicidePreventionSummit/components/TheFooter.vue'),
        }
    },
    {
        path: '/suicideprevention/upgrade/confirmation',
        name: 'summit.upgrade.confirmation2',
        components: {
            default: () => import('@/modules/events/suicidePreventionSummit/components/UpgradeConfirmation.vue'),
            footer: () => import('@/modules/events/suicidePreventionSummit/components/TheFooter.vue'),
        }
    },
    {
        path: '/suicideprevention/aca',
        name: 'summit.aca.index',
        components: {
            default: () => import('@/modules/events/suicidePreventionSummit/views/Index.vue'),
            footer: () => import('@/modules/events/suicidePreventionSummit/components/TheFooter.vue'),
        },
        meta: {
            eventId: '46',
            headerLogos: [
                {
                    href: '//www.counseling.org/',
                    imgSrc: 'https://d9hv9sikl36u8.cloudfront.net/images/suicidePreventionSummit/logos/ACA Logo.png',
                    imgAlt: 'American Counseling Association Logo',
                    style: 'max-height:50px;margin-top:.8rem;margin-bottom: .5rem;max-width: 106px;'
                }
            ]
        }
    },
    {
        path: '/suicideprevention/ccpa',
        name: 'summit.ccpa.index',
        components: {
            default: () => import('@/modules/events/suicidePreventionSummit/views/Index.vue'),
            footer: () => import('@/modules/events/suicidePreventionSummit/components/TheFooter.vue'),
        },
        meta: {
            eventId: '46',
            isCcpa: true,
            headerLogos: [
                {
                    href: 'https://www.ccpa-accp.ca/',
                    imgSrc: 'https://d9hv9sikl36u8.cloudfront.net/images/suicidePreventionSummit/ccpa-logo.png',
                    imgAlt: 'Canadian Counselling and Psychotherapy Association Logo',
                    style: 'max-height:50px;margin-top:.8rem;margin-bottom: .5rem;max-width: 153px;'
                }
            ]
        }
    },
    {
        path: '/suicideprevention/nbcc',
        name: 'summit.nbcc.index',
        components: {
            default: () => import('@/modules/events/suicidePreventionSummit/views/Index.vue'),
            footer: () => import('@/modules/events/suicidePreventionSummit/components/TheFooter.vue'),
        },
        meta: {
            eventId: '46',
            headerLogos: [
                {
                    href: 'https://www.nbcc.org/',
                    imgSrc: 'https://d9hv9sikl36u8.cloudfront.net/images/suicidePreventionSummit/NBCCFlogo.png',
                    imgAlt: 'National Board for Certified Counselors Logo',
                    style: 'max-height:50px;margin-top:.8rem;margin-bottom: .5rem;max-width: 177px;'
                },
                {
                    href: 'https://www.cce-global.org/',
                    imgSrc: 'https://d9hv9sikl36u8.cloudfront.net/images/suicidePreventionSummit/CCE-logo.jpg',
                    imgAlt: 'Center for Credentialing & Education Logo',
                    style: 'max-height:50px;margin-top:.6rem;max-width: 177px;'
                }
            ]
        }
    },
    {
        path: '/suicideprevention/aas',
        name: 'summit.aas.index',
        components: {
            default: () => import('@/modules/events/suicidePreventionSummit/views/Index.vue'),
            footer: () => import('@/modules/events/suicidePreventionSummit/components/TheFooter.vue'),
        },
        meta: {
            eventId: '46',
            headerLogos: [
                {
                    href: '//suicidology.org',
                    imgSrc: 'https://d9hv9sikl36u8.cloudfront.net/images/suicidePreventionSummit/logos/AAS-LOGO.png',
                    imgAlt: 'American Association of Suicidology Logo',
                    style: 'max-height:50px;margin-top:.8rem;margin-bottom: .5rem;max-width: 196px;'
                }
            ]
        }
    },
    {
        path: '/suicideprevention/naadac',
        name: 'summit.naadac.index',
        components: {
            default: () => import('@/modules/events/suicidePreventionSummit/views/Index.vue'),
            footer: () => import('@/modules/events/suicidePreventionSummit/components/TheFooter.vue'),
        },
        meta: {
            eventId: '46',
            headerLogos: [
                {
                    href: 'https://www.naadac.org/',
                    imgSrc: 'https://d9hv9sikl36u8.cloudfront.net/images/app/NAADAC_Logo_Current_Blue.webp',
                    imgAlt: 'The Association for Addiction Professionals (NAADAC) Logo',
                    style: 'max-height:50px;margin-top:.8rem;margin-bottom: .5rem;max-width: 120px;'
                }
            ]
        }
    },
    // {
    //     path: '/suicideprevention/valant',
    //     name: 'summit.valant.index',
    //     components: {
    //         default: () => import('@/modules/events/suicidePreventionSummit/views/Index.vue'),
    //         footer: () => import('@/modules/events/suicidePreventionSummit/components/TheFooter.vue'),
    //     },
    //     meta: {
    //         headerLogos: [
    //             {
    //                 href: 'https://www.valant.io/?utm_source=%20mental_health_academy%20&utm_medium=website&utm_campaign=suicide_prevention_summit_2023',
    //                 imgSrc: 'https://d9hv9sikl36u8.cloudfront.net/images/suicidePreventionSummit/logos/valant_logo.svg',
    //                 imgAlt: 'Valant Logo',
    //                 style: 'max-height:50px;margin-top:.8rem;margin-bottom: .5rem;max-width: 160.5px;'
    //             }
    //         ]
    //     }
    // },
    // {
    //     path: '/suicideprevention/aas/confirmation',
    //     name: 'summit.aas.donation',
    //     components: {
    //         default: () => import('@/modules/events/suicidePreventionSummit/views/Donation.vue'),
    //         header: () => import('@/modules/events/suicidePreventionSummit/components/TheHeader.vue'),
    //         footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
    //     }
    // },
    // {
    //     path: '/suicideprevention/nbcc',
    //     name: 'summit.nbcc.index',
    //     components: {
    //         default: () => import('@/modules/events/suicidePreventionSummit/views/Index.vue'),
    //         footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
    //     },
    //     meta: {
    //         registrationSource: '/suicideprevention/nbcc',
    //         partner: "nbcc"
    //     }
    // },
    // {
    //     path: '/suicideprevention/nbcc/confirmation',
    //     name: 'summit.nbcc.donation',
    //     components: {
    //         default: () => import('@/modules/events/suicidePreventionSummit/views/Donation.vue'),
    //         footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
    //     }
    // },
    // {
    //     path: '/suicideprevention/aas',
    //     name: 'summit.aas.index',
    //     components: {
    //         default: () => import('@/modules/events/suicidePreventionSummit/views/Index.vue'),
    //         footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
    //     },
    //     meta: {
    //         registrationSource: '/suicideprevention/aas'
    //     }
    // },
    // {
    //     path: '/suicideprevention/aas/confirmation',
    //     name: 'summit.aas.donation',
    //     components: {
    //         default: () => import('@/modules/events/suicidePreventionSummit/views/Donation.vue'),
    //         footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
    //     }
    // },
    // {
    //     path: '/suicideprevention/aca',
    //     name: 'summit.aca.index',
    //     components: {
    //         default: () => import('@/modules/events/suicidePreventionSummit/views/Index.vue'),
    //         footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
    //     },
    //     meta: {
    //         registrationSource: '/suicideprevention/aca'
    //     }
    // },
    // {
    //     path: '/suicideprevention/aca/confirmation',
    //     name: 'summit.aca.donation',
    //     components: {
    //         default: () => import('@/modules/events/suicidePreventionSummit/views/Donation.vue'),
    //         footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
    //     }
    // },
    // {
    //     path: '/suicideprevention/ccpa',
    //     name: 'summit.ccpa.index',
    //     components: {
    //         default: () => import('@/modules/events/suicidePreventionSummit/views/Index.vue'),
    //         footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
    //     },
    //     meta: {
    //         registrationSource: '/suicideprevention/ccpa'
    //     }
    // },
    // {
    //     path: '/suicideprevention/ccpa/confirmation',
    //     name: 'summit.ccpa.donation',
    //     components: {
    //         default: () => import('@/modules/events/suicidePreventionSummit/views/Donation.vue'),
    //         footer: () => import(/* webpackChunkName: "summit" */ '@/views/public/footer/index.vue'),
    //     }
    // },
    {
        path: '/suicideprevention/invoice',
        name: 'suicideprevention.invoice',
        components: {
            default: () => import(/* webpackChunkName: "mha.sps" */ '@/modules/events/suicidePreventionSummit/views/Invoice.vue'),
            header: () => import(/* webpackChunkName: "mha.sps" */ '@/modules/events/document/components/TheHeader.vue'),
            footer: () => import(/* webpackChunkName: "mha.sps" */ '@/views/public/footer/index.vue'),
        },
        meta: {
            showTagline: true
        }
    },
    {
        path: '/events/:type/:document',
        name: 'event.document',
        components: {
            default: () => import(/* webpackChunkName: "event.document" */ '@/modules/events/document/components/Index.vue'),
            header: () => import(/* webpackChunkName: "event.document" */ '@/modules/events/document/components/TheHeader.vue'),
            footer: () => import(/* webpackChunkName: "event.document" */ '@/views/public/footer/index.vue'),
        },
        meta: {
            showTagline: true
        }
    }
]
